import { ILoginFormLang } from '../../../types/lang'

export const loginFormLang: ILoginFormLang = {
	login_form: {
		field_user_name_label: 'Имя пользователя',
		field_user_name_placeholder: 'Имя пользователя',
		field_password_label: 'Пароль',
		field_password_placeholder: 'Пароль',
		msg_login_success: 'Добро пожаловать, {{name}}!',
		btn_login: 'Войти',
	}
}